import { NavLink } from "react-router-dom";

type LinkButtonProps = {
  to: string;
  className?: string;
  title?: string;
  children: React.ReactNode;
  target?: "_blank" | "_self";
};

export function LinkButton({
  to,
  className = "self-center",
  title = "",
  children,
  target = "_self",
}: LinkButtonProps) {
  return (
    <NavLink className={className} to={to} title={title} target={target}>
      {children}
    </NavLink>
  );
}
